import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '=',
        filter: '=',
        classifiers: '=',
        filterOverview: '=',
        defaultFilter: '=',
        sites: '=',
        view: '=',
        selectedItems: '='
    },
    template: `
        <div class="block02" ng-class="{ open: vm.filters === true }" ng-if="vm.view !== 'modal'">
            <div class="heading01 theme01">
                <h3 ng-click="vm.changeFilter()">{{ 'filter.Filters' | translate }}</h3>
            </div>
            <div class="table-filters" ng-if="vm.filters === true">
                <form class="form form-filter type02" ng-submit="vm.applyFilter()">
                    <div class="fields">
                        <div class="row separated row-flex02">
                            <label class="label">{{ 'filter.Site' | translate }}</label>
                            <div class="items">
                                <div
                                    ng-dropdown-multiselect=""
                                    options="vm.multiFilter.sites.options"
                                    selected-model="vm.multiFilter.sites.model"
                                    extra-settings="vm.multiFilter.sites.settings"
                                    ng-click="vm.updateEmployees()"
                                    translation-texts="vm.filterTranslations"
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="row row-md row-flex02">
                            <label class="label">{{ 'filter.Employee department' | translate }}</label>
                            <div class="items">
                                <div ng-dropdown-multiselect=""
                                    options="vm.FilterService.departmentSelect.options"
                                    selected-model="vm.FilterService.departmentSelect.models"
                                    extra-settings="vm.FilterService.departmentSelect.settings"
                                    events="vm.FilterService.departmentSelect.events"
                                    translation-texts="vm.filterTranslations"
                                ></div>
                            </div>
                        </div>
                        <div class="row row-flex02">
                            <label class="label">{{ 'filter.Employee role' | translate }}</label>
                            <div class="items">
                                <div ng-dropdown-multiselect=""
                                    options="vm.FilterService.roleSelect.options"
                                    selected-model="vm.FilterService.roleSelect.models"
                                    extra-settings="vm.FilterService.roleSelect.settings"
                                    events="vm.FilterService.roleSelect.events"
                                    translation-texts="vm.filterTranslations"
                                ></div>
                            </div>
                        </div>
                        <div class="row row-flex02">
                            <label class="label">{{ 'filter.Employee level' | translate }}</label>
                            <div class="items">
                                <div ng-dropdown-multiselect=""
                                    options="vm.FilterService.levelSelect.options"
                                    selected-model="vm.FilterService.levelSelect.models"
                                    extra-settings="vm.FilterService.levelSelect.settings"
                                    events="vm.FilterService.levelSelect.events"
                                    translation-texts="vm.filterTranslations"
                                ></div>
                            </div>
                        </div>
                        <div class="row row-flex02">
                            <label class="label">{{ 'filter.Employee status' | translate }}</label>
                            <div class="items">
                                <div
                                    ng-dropdown-multiselect=""
                                    options="vm.multiFilter.employeeStatuses.options"
                                    selected-model="vm.multiFilter.employeeStatuses.model"
                                    extra-settings="vm.multiFilter.employeeStatuses.settings"
                                    translation-texts="vm.filterTranslations">
                                </div>
                            </div>
                        </div>
                        <div class="row row-flex02">
                            <label class="label">{{ 'filter.Employee account' | translate }}</label>
                            <div class="items">
                                <div
                                    ng-dropdown-multiselect=""
                                    options="vm.multiFilter.employeeAccounts.options"
                                    selected-model="vm.multiFilter.employeeAccounts.model"
                                    extra-settings="vm.multiFilter.employeeAccounts.settings"
                                    translation-texts="vm.filterTranslations">
                                </div>
                            </div>
                        </div>
                        <div class="row row-flex02 row-date-input">
                            <label class="label">
                                {{ 'filter.Working' | translate }}
                            </label>
                            <div class="items">
                                <datepicker-api ng-model="vm.filter.workingFrom"></datepicker-api>
                                <datepicker-api ng-model="vm.filter.workingTo"></datepicker-api>
                            </div>
                        </div>
                        <div class="row row-md row-separated row-flex02">
                            <label class="label">{{ 'filter.Employee' | translate }}</label>
                            <div class="items">
                                <autocomplete
                                    label-attribute="'displayName'"
                                    selected-item="vm.selectedEmployee"
                                    ng-model="vm.filter.userId"
                                    value-attribute="'id'"
                                    placeholder="vm.$translate.instant('filter.Find an employee')"
                                    query="vm.queryUsers(input)"
                                />
                            </div>
                        </div>
                        <div class="row row-flex02">
                            <label class="label">{{ 'filter.Employee course progress status' | translate }}</label>
                            <div class="items">
                                <div
                                    ng-dropdown-multiselect=""
                                    options="vm.multiFilter.statuses.options"
                                    selected-model="vm.multiFilter.statuses.model"
                                    extra-settings="vm.multiFilter.statuses.settings"
                                    translation-texts="vm.filterTranslations">
                                </div>
                            </div>
                        </div>
                        <div class="row row-flex02">
                            <label class="label">{{ 'filter.Course name' | translate }}</label>
                            <div class="items">
                                <input type="text" ng-model="vm.filter.course" class="form-control">
                            </div>
                        </div>
                        <div ng-if="vm.isOptionalCoursesEnabled" class="row row-flex02">
                            <label class="label">{{ 'filter.Participation' | translate }}</label>
                            <div class="items">
                                <div ng-dropdown-multiselect=""
                                    options="vm.multiFilter.participationTypes.options"
                                    selected-model="vm.multiFilter.participationTypes.model"
                                    extra-settings="vm.multiFilter.participationTypes.settings"
                                    translation-texts="vm.filterTranslations">
                                ></div>
                            </div>
                        </div>
                    </div>
                    <ul class="actions01">
                        <li><input type="button" ng-click="vm.resetFilter()" class="btn discrete" value="{{ 'filter.Reset' | translate }}"></li>
                        <li><input type="submit" class="btn main" value="{{ 'filter.Generate report' | translate }}"></li>
                    </ul>
                </form>
            </div>
        </div>
    `
})
export default class {
    constructor ($translate, lodash,
                 TokenService, MomentService, StringService, PrivilegeService,
                 SiteService, FilterOverviewService, FilterService,
                 UserResource,
                 CLASSIFIER_ENUM, ROLE_CODE_ENUM, COURSE_STATUS_TYPE_ENUM,
                 USER_STATUS_ENUM, COURSE_TARGET_NEED_TYPE_ENUM, USER_ACTIVATION_STATUS_ENUM, $window) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.TokenService = TokenService;
        this.MomentService = MomentService;
        this.PrivilegeService = PrivilegeService;
        this.SiteService = SiteService;
        this.StringService = StringService;
        this.FilterOverviewService = FilterOverviewService;
        this.FilterService = FilterService;
        this.UserResource = UserResource;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.ROLE_CODE_ENUM = ROLE_CODE_ENUM;
        this.COURSE_STATUS_TYPE_ENUM = COURSE_STATUS_TYPE_ENUM;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.COURSE_TARGET_NEED_TYPE_ENUM = COURSE_TARGET_NEED_TYPE_ENUM;
        this.USER_ACTIVATION_STATUS_ENUM = USER_ACTIVATION_STATUS_ENUM;
        this.$window = $window;
    }

    $onInit () {
        this.isOptionalCoursesEnabled = this.TokenService.isOptionalCoursesModuleEnabled();
        this.departments = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.DEPARTMENT);
        this.roles = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.ROLE);
        this.levels = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.LEVEL);

        this.initMultiFilter();

        // note the string object keys which represent multi-filter fields
        this.filterOverview = {
            labels: {
                workingSince: this.$translate.instant('filter.Working since'),
                period: this.$translate.instant('filter.Period'),
                siteIds: this.$translate.instant('filter.Site'),
                departmentIds: this.$translate.instant('filter.Employee department'),
                roleIds: this.$translate.instant('filter.Employee role'),
                levelIds: this.$translate.instant('filter.Employee level'),
                userId: this.$translate.instant('filter.Employee'),
                course: this.$translate.instant('filter.Course name must contain'),
                statuses: this.$translate.instant('filter.Employee course progress status'),
                employeeStatuses: this.$translate.instant('filter.Employee status'),
                employeeAccounts: this.$translate.instant('filter.Employee account')
            },
            values: {}
        };

        if (this.isOptionalCoursesEnabled) {
            this.filterOverview.labels.participationTypes = this.$translate.instant('filter.Participation');
        }

        this.filterTranslations = this.FilterService.getTranslations();
        this.updateFilterOverview();

        this.filters = JSON.parse(this.$window.localStorage.getItem('is_courses_in_progress_report_filter_opened'));
    }

    changeFilter () {
        this.filters = !this.filters;
        this.$window.localStorage.setItem('is_courses_in_progress_report_filter_opened', this.filters);
    }

    initMultiFilter () {
        this.FilterService.init(this.classifiers);

        const siteOptions = this.sites.map(site => {
            return {
                value: site.id,
                label: site.name
            };
        });
        const siteOptionsSelected = siteOptions.map(site => site);

        const statusOptions = [
            { value: this.COURSE_STATUS_TYPE_ENUM.KEYS.NOT_STARTED, label: this.COURSE_STATUS_TYPE_ENUM.LABELS.NOT_STARTED },
            { value: this.COURSE_STATUS_TYPE_ENUM.KEYS.IN_PROGRESS, label: this.COURSE_STATUS_TYPE_ENUM.LABELS.IN_PROGRESS }
        ];
        const statusOptionsSelected = [statusOptions[0], statusOptions[1]];

        const employeeAccountsOptions = [
            { value: this.USER_ACTIVATION_STATUS_ENUM.KEYS.ACTIVATED, label: this.$translate.instant('filter.Activated') },
            { value: this.USER_ACTIVATION_STATUS_ENUM.KEYS.NOT_ACTIVATED, label: this.$translate.instant('filter.Not activated') }
        ];
        const employeeAccountsOptionsSelected = [employeeAccountsOptions[0], employeeAccountsOptions[1]];

        const employeeStatusOptions = [
            { value: this.USER_STATUS_ENUM.KEYS.ACTIVE, label: this.USER_STATUS_ENUM.LABELS.ACTIVE },
            { value: this.USER_STATUS_ENUM.KEYS.INACTIVE, label: this.USER_STATUS_ENUM.LABELS.INACTIVE },
            { value: this.USER_STATUS_ENUM.KEYS.NOT_STARTED, label: this.USER_STATUS_ENUM.LABELS.NOT_STARTED }
        ];
        const employeeStatusOptionsSelected = [employeeStatusOptions[0], employeeStatusOptions[2]];

        this.multiFilter = {
            statuses: {
                model: statusOptionsSelected,
                options: statusOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: false,
                    showUncheckAll: false,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            },
            employeeStatuses: {
                model: employeeStatusOptionsSelected,
                options: employeeStatusOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: false,
                    showUncheckAll: false,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            },
            sites: {
                model: siteOptionsSelected,
                options: siteOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            },
            employeeAccounts: {
                model: employeeAccountsOptionsSelected,
                options: employeeAccountsOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: false,
                    showUncheckAll: false,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => itemText
                }
            }
        };
        if (this.isOptionalCoursesEnabled) {
            const participationOptions = [
                { value: this.COURSE_TARGET_NEED_TYPE_ENUM.KEYS.COMPULSORY, label: this.COURSE_TARGET_NEED_TYPE_ENUM.LABELS.COMPULSORY },
                { value: this.COURSE_TARGET_NEED_TYPE_ENUM.KEYS.OPTIONAL, label: this.COURSE_TARGET_NEED_TYPE_ENUM.LABELS.OPTIONAL }
            ];
            const participationOptionsSelected = [...participationOptions];

            this.multiFilter.participationTypes = {
                model: participationOptionsSelected,
                options: participationOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            };
        }

        // this is used when filter is reset
        this.defaultMultiFilter = angular.copy(this.multiFilter);
    }

    queryUsers (input) {
        const params = {
            roleCode: this.ROLE_CODE_ENUM.KEYS.EMPLOYEE,
            name: input,
            pageSize: 0,
            privilegesCheck: false
        };
        const siteIds = this.multiFilter.sites.model.map(site => site.value);
        if (siteIds) {
            params.siteIds = siteIds;
        }
        return this.UserResource.getUsers({}, params).$promise;
    }

    applyFilter () {
        const siteIds = !this.multiFilter.sites.model.length ? [-1] : this.multiFilter.sites.model.map(site => site.value);
        const statuses = !this.multiFilter.statuses.model.length ? [-1] : this.multiFilter.statuses.model.map(status => status.value);
        const employeeStatuses = !this.multiFilter.employeeStatuses.model.length ? [] : this.multiFilter.employeeStatuses.model.map(status => status.value);
        const employeeAccounts = !this.multiFilter.employeeAccounts.model.length ? [] : this.multiFilter.employeeAccounts.model.map(status => status.value);
        if (this.isOptionalCoursesEnabled) {
            const participationTypes = !this.multiFilter.participationTypes.model.length ? [] : this.multiFilter.participationTypes.model.map(type => type.value);
            this.filter = this.lodash.assign(this.filter, { participationTypes });
        }

        this.filter = this.lodash.assign(this.filter, { siteIds });
        this.filter = this.lodash.assign(this.filter, { statuses });
        this.filter = this.lodash.assign(this.filter, { employeeStatuses });
        this.filter = this.lodash.assign(this.filter, { employeeAccounts });

        this.filter.departmentIds = this.FilterService.departmentSelect.models
            .filter((department) => department.id !== null)
            .map((department) => department.id);

        this.filter.roleIds = this.FilterService.roleSelect.models
            .filter((role) => role.id !== null)
            .map(role => role.id);

        this.filter.levelIds = this.FilterService.levelSelect.models
            .filter((level) => level.id !== null)
            .map(level => level.id);

        this.list.fetch({}, this.filter).then(() => {
            this.updateFilterOverview();
            this.selectedItems = [];
        });
    }

    resetFilter () {
        this.filter = angular.copy(this.defaultFilter);
        this.multiFilter = angular.copy(this.defaultMultiFilter);
        this.FilterService.initClassifierMultiFilter();
        this.applyFilter();
        this.selectedEmployee = null;
    }

    updateFilterOverview () {
        if (!this.list.invalid) {
            // empty old values
            this.filterOverview.values = {};
            this.filterOverview.fullText = {};
            this.lodash.forEach(this.filter, (value, key) => {
                if (key === 'siteIds' && value[0] !== -1) {
                    const siteValues = value.map((siteId) => this.lodash.find(this.sites, { id: siteId }).name).join('; ');
                    this.filterOverview.values[key] = this.StringService.cutStringAndAppendEnding(siteValues);
                    this.filterOverview.fullText[key] = siteValues;
                }
                else if (key === 'departmentIds') {
                    this.filterOverview.values[key] = value.map((departmentId) => this.lodash.find(
                        this.FilterService.departments, { id: departmentId }).value
                    ).join('; ');
                }
                else if (key === 'roleIds') {
                    this.filterOverview.values[key] = value.map((roleId) => this.lodash.find(
                        this.FilterService.roles, { id: roleId }).value
                    ).join('; ');
                }
                else if (key === 'levelIds') {
                    this.filterOverview.values[key] = value.map((levelId) => this.lodash.find(
                        this.FilterService.levels, { id: levelId }).value
                    ).join('; ');
                }
                else if (key === 'course' && value) {
                    this.filterOverview.values[key] = value;
                }
                else if (key === 'userId') {
                    this.filterOverview.values[key] = this.selectedEmployee.displayName;
                }
                else if (key === 'statuses') {
                    this.filterOverview.values[key] = value.map((status) => this.COURSE_STATUS_TYPE_ENUM.LABELS[status]).join('; ');
                }
                else if (key === 'employeeStatuses') {
                    this.filterOverview.values[key] = value.map((status) => this.USER_STATUS_ENUM.LABELS[status]).join('; ');
                }
                else if (key === 'participationTypes' && this.isOptionalCoursesEnabled) {
                    this.filterOverview.values[key] = value.map((type) => this.COURSE_TARGET_NEED_TYPE_ENUM.LABELS[type]).join('; ');
                }
            });
            // get filter period
            if (this.filter.workingTo || this.filter.workingFrom) {
                this.filterOverview.values.workingSince = this.FilterOverviewService.convertFromToFilterFields(this.filter.workingFrom, this.filter.workingTo);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/reports/courseprogress/filter/index.js